<template lang="pug">
  div
    page_header(title="Users", subhead="Add New")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "users.index"}')
        i.feather-arrow-left
        | Back
    
    .row
      .col-sm-6
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-12
                form_input(type="text" name="name" label="Name" placeholder="Enter User Name" v-model="form.name")              
                form_input(type="text" name="email" label="Email" placeholder="Enter Email ID" v-model="form.email")
                form_input(type="text" name="phone" label="Phone" placeholder="Enter Phone Number" v-model="form.phone")
                form_select(label="Role" name="role" :options="roles" :item="{value:'id', label:'name'}" v-model="form.role")
            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Users',
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn
  },
  data(){
    return {
      roles: [],
      form: {
        name: '',
        email: '',
        phone: '',
        role: ''
      },
      blank: {
        name: '',
        email: '',
        phone: '',
        role: ''
      }
    }
  },
  computed: {
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    resetForm(){
      this.form = JSON.parse(JSON.stringify(this.blank));
    },
    submit(){
      var vm = this;
      this.call({_vm:this, endpoint: 'admin/users', method: 'POST', data: this.form}).then(()=>{
        vm.resetForm();
      })
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: 'admin/users/create', method: 'GET'}).then((data)=>{
      vm.roles = data;
    })
  }
}
</script>
